export default __webpack_public_path__ + "static/media/Sunbelt-Button.09be667f.png";